import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Thumbnail from '../thumbnail/index';

const VideoCard = ({
    type,
    imageCuts,
    imageAlt,
    blurb,
    duration,
    lastPublish,
    playing,
    description,
    lang,
}) => {

    const videoCardClass = classNames({
        'video-card': true,
        [`video-card--${type}`]: true,
        'video-card--active': playing,
    });

    const date = moment(lastPublish).locale(lang)
        .format('LL');

    return (
        <div className={videoCardClass}>
            <Thumbnail imageCuts={imageCuts} duration={duration} playing={playing} imageAlt={imageAlt} />
            <div className="video-card__content">
                <p className="video-card__blurb">{blurb}</p>
                <p className="video-card__date">{date}</p>
                {description && <p className="video-card__description">{description}</p>}
            </div>
        </div>
    );

};

export const videoCardTypes = {
    LANDSCAPE: 'landscape',
    PORTRAIT: 'portrait',
};

VideoCard.types = videoCardTypes;

VideoCard.propTypes = {
    type: PropTypes.string,
    imageCuts: PropTypes.array.isRequired,
    imageAlt: PropTypes.string.isRequired,
    blurb: PropTypes.string,
    duration: PropTypes.string,
    lastPublish: PropTypes.string,
    playing: PropTypes.bool,
    lang: PropTypes.string,
};

VideoCard.defaultProps = {
    type: VideoCard.types.PORTRAIT,
    imageCuts: [],
    imageAlt: '',
    blurb: '',
    duration: '',
    lastPublish: '',
    playing: false,
    lang: 'en',
};

export default VideoCard;
